import { Bidi } from './Bidi'
import { Chip, type ChipVariant } from './Chip'

/**
 * P15 §8 rule 3 — the per-row outcome report both the bulk-invite step and the copy-members
 * screen want: `positive` (copied/registered/added), `neutral` (a skip — "a skip is a normal
 * outcome, not an error", P15 §6), `negative` (invalid/failed). A shell component rather than a
 * local helper duplicated in each screen's own file.
 *
 * Purely presentational — every label is a prop, so this carries no i18n namespace of its own
 * and no knowledge of either caller's outcome vocabulary.
 */
export type OutcomeTone = 'positive' | 'neutral' | 'negative'

export interface OutcomeRowView {
  readonly key: string
  readonly label: string
  readonly detail?: string
  readonly outcomeLabel: string
  readonly tone: OutcomeTone
}

const TONE_VARIANT: Readonly<Record<OutcomeTone, ChipVariant>> = {
  positive: 'result',
  neutral: 'default',
  negative: 'fail',
}

export function OutcomeReport({ rows }: { readonly rows: readonly OutcomeRowView[] }): JSX.Element {
  return (
    <>
      {rows.map((row) => (
        <div className="row" key={row.key}>
          <div className="l">
            <Bidi>{row.label}</Bidi>
            {row.detail !== undefined ? <div className="gsub">{row.detail}</div> : null}
          </div>
          <div className="r">
            <Chip variant={TONE_VARIANT[row.tone]}>{row.outcomeLabel}</Chip>
          </div>
        </div>
      ))}
    </>
  )
}
